var _path, _g, _path2, _g2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReset = function SvgReset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "reset_svg__a",
    width: 8,
    height: 8,
    x: 2,
    y: 6,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    stroke: "currentColor",
    strokeWidth: 0.741,
    d: "M9.573 7.05H2.537v5.74h7.036z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#reset_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.184,
    cy: 5.184,
    r: 4.684,
    stroke: "currentColor",
    transform: "matrix(-1 0 0 1 13.184 2.792)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "reset_svg__b",
    width: 9,
    height: 8,
    x: 5,
    y: 2,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    stroke: "currentColor",
    strokeWidth: 0.741,
    d: "M12.814 3.162H5.778v5.74h7.036z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#reset_svg__b)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.184,
    cy: 5.184,
    r: 4.684,
    stroke: "currentColor",
    transform: "matrix(-1 0 0 1 13.184 2.792)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.1,
    d: "m10.916 7.976 1.62 1.944 1.62-1.944M5.084 7.976l-1.62-1.944-1.62 1.944"
  })));
};
export default SvgReset;